export enum LoginValidInput {
  invalid = "INVALID",
  valid = "VALID",
}
